/**
 * Image Optimizer Utility
 * Handles WebP format with fallback to original format
 * Includes lazy loading and caching strategies
 */

let _supportsWebP = null;

const checkWebPSupport = () => {
  if (_supportsWebP !== null) return _supportsWebP;
  try {
    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 1;
    _supportsWebP = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  } catch (e) {
    _supportsWebP = false;
  }
  return _supportsWebP;
};

export const getOptimizedImage = (imagePath, fallbackPath = null) => {
  const supportsWebP = checkWebPSupport();

  // Convert path to WebP
  const getWebPPath = (path) => {
    if (!path) return null;
    // If already WebP, return as is
    if (path.endsWith('.webp')) return path;
    // Convert to WebP
    return path.replace(/\.(png|jpg|jpeg)$/i, '.webp');
  };

  const webpPath = getWebPPath(imagePath);
  const finalPath = supportsWebP && webpPath ? webpPath : (fallbackPath || imagePath);

  return {
    src: finalPath,
    fallback: fallbackPath || imagePath,
    supportsWebP: supportsWebP,
  };
};

export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

